import classNames from 'classnames'
import React, { ReactNode } from 'react'

export interface CardProps {
    children: ReactNode | ReactNode[]
    modifier?: string
    className?: string
    hasContent?: boolean
    variant?: 'secondary' | 'ternary' | 'quaternary' | 'quinary'
    padding?: 'small' | 'medium' | 'large'
}

export const Card = (props: CardProps): JSX.Element => {
    const className: string = classNames(
        'card',
        props.variant && `card--variant-${props.variant}`,
        props.padding && `card--padding-${props.padding}`,
        props.modifier,
        props.className,
    )

    const renderContent = () => {
        return <div className="card__content">{props.children}</div>
    }

    return <div className={className}>{props.hasContent ? renderContent() : props.children}</div>
}
